/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var DemoFollowUpAction;

(function (DemoFollowUpAction) {
  DemoFollowUpAction["SEND_INFORMATION"] = "send_information";
  DemoFollowUpAction["SEND_AGREEMENT"] = "send_agreement";
  DemoFollowUpAction["RESCHEDULE_DEMO"] = "reschedule_demo";
  DemoFollowUpAction["NO_FURTHER_ACTION"] = "no_further_action";
})(DemoFollowUpAction || (DemoFollowUpAction = {}));